export default class AudioPlayer {
    constructor() {
        this.track = document.getElementById("track");
        this.thumbnail = document.getElementById("thumbnail");
        this.background = document.getElementById("background");
        this.trackArtist = document.getElementById("track-artist");
        this.trackTitle = document.getElementById("track-title");
        this.progressBar = document.getElementById("progressBar");
        this.currentTime = document.getElementById("currentTime");
        this.durationTime = document.getElementById("durationTime");
        this.audioPlayer = document.getElementById("audio-player");

        this.play = document.getElementById("play");
        this.pause = document.getElementById("pause");
        this.next = document.getElementById("next-track");
        this.prev = document.getElementById("prev-track");
        this.nextPodcast = document.getElementById("next-podcast");
        this.prevPodcast = document.getElementById("prev-podcast");
        this.trackIndex = 0;

        this.playing = true;

        this.events();
    }

    events() {
        const self = this;

        if (this.play) {
            this.play.addEventListener("click", this.pausePlay.bind(this));
        }

        if (this.pause) {
            this.pause.style.display = "none";
            this.pause.addEventListener("click", this.pausePlay.bind(this));
        }

        if (this.track && this.progressBar) {
            setInterval(self.progressValue.bind(self), 500);
        }

        if (this.progressBar) {
            this.progressBar.addEventListener(
                "click",
                this.changeProgressBar.bind(this)
            );
        }

        if (this.track) {
            this.track.addEventListener("ended", this.checkEnded.bind(this));
        }

        if (this.audioPlayer && this.track) {
            setInterval(function () {
                if (
                    self.getUrlParameter("autoplay") &&
                    self.track.currentTime == 0
                ) {
                    self.audioPlayer.classList.add("player-playing");
                    self.audioPlayer.classList.remove("player-paused");
                    self.track.play();
                }
            }, 1000);
        }
    }

    pausePlay(e) {
        e.preventDefault();

        if (this.playing) {
            this.track.play();
            this.playing = false;
            this.audioPlayer.classList.add("player-playing");
            this.audioPlayer.classList.remove("player-paused");
        } else {
            this.track.pause();
            this.playing = true;
            this.audioPlayer.classList.remove("player-playing");
            this.audioPlayer.classList.add("player-paused");
        }
    }

    progressValue() {
        this.progressBar.max = this.track.duration;
        this.progressBar.value = this.track.currentTime;

        this.currentTime.textContent = this.formatTime(this.track.currentTime);
        this.durationTime.textContent = this.formatTime(this.track.duration);
        if (this.progressBar) {
            this.progressBar.style.backgroundSize =
                ((this.progressBar.value - this.progressBar.min) * 100) /
                    (this.progressBar.max - this.progressBar.min) +
                "% 100%";
        }
    }

    formatTime(sec) {
        const minutes = Math.floor(sec / 60);
        let seconds = Math.floor(sec - minutes * 60);
        if (seconds < 10) {
            seconds = `0${seconds}`;
        }
        return `${minutes}:${seconds}`;
    }

    changeProgressBar() {
        this.track.currentTime = this.progressBar.value;

        if (this.progressBar) {
            this.progressBar.style.backgroundSize =
                ((this.progressBar.value - this.progressBar.min) * 100) /
                    (this.progressBar.max - this.progressBar.min) +
                "% 100%";
        }
    }

    checkEnded() {
        const isPlayer = this.getUrlParameter("player");
        const prevAudio = this.getPrevPodcastUrl();
        const nextAudio = this.getNextPodcastUrl();

        if (isPlayer) {
            if (prevAudio) {
                window.location.href = prevAudio + "?player=true&autoplay=true";
            } else {
                window.location.href = nextAudio + "?player=true&autoplay=true";
            }
        } else {
            if (prevAudio) {
                window.location.href = prevAudio;
            } else {
                window.location.href = nextAudio;
            }
        }
    }

    getUrlParameter(sParam) {
        const sPageURL = window.location.search.substring(1);
        const sURLVariables = sPageURL.split("&");

        for (let i = 0; i < sURLVariables.length; i++) {
            const sParameterName = sURLVariables[i].split("=");

            if (sParameterName[0] == sParam) {
                return sParameterName[1];
            }
        }
    }

    getNextPodcastUrl() {
        let url = null;

        if (this.nextPodcast) {
            url = this.nextPodcast.href;
        }

        return url;
    }

    getPrevPodcastUrl() {
        let url = null;

        if (this.prevPodcast) {
            url = this.prevPodcast.href;
        }

        return url;
    }
}
